import { all, fork } from 'redux-saga/effects';

import todoSaga from './todo/sagas';
import homeSaga from './HomePage/sagas';
import planSaga from './PlanPage/sagas';
import internationalServiceSaga from './InternationalServices/sagas';
import checkoutSaga from './Checkout/sagas';
import trackOrderSaga from './TrackOrder/sagas';
import activationSaga from './Activation/sagas';
import postActivationSaga from './PostActivation/sagas';
import billingSaga from './Billing/sagas';
import deviceSaga from './EarthlinkDevice/sagas';

export function* rootSaga() {
    yield all([
        fork(todoSaga),
        fork(homeSaga),
        fork(planSaga),
        fork(internationalServiceSaga),
        fork(checkoutSaga),
        fork(trackOrderSaga),
        fork(activationSaga),
        fork(postActivationSaga),
        fork(billingSaga),
        fork(deviceSaga),
    ]);
}
